import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faBriefcase } from "@fortawesome/free-solid-svg-icons";
import {
  faGithub,
  faTwitter,
  faLinkedin
} from "@fortawesome/free-brands-svg-icons";

import Fade from "react-reveal/Fade";

import Hero from "../blocks/Hero";
import Contact from "../blocks/Contact";

const Home = props => {
  return (
    <div className="Home">
      <div className="row">
        <Hero>
          <div className="hero-text">
            <h1>Hello</h1>
            <p>
              I'm <span style={{ color: "$main-color" }}>Koen</span>.
              <br />A Webmaster & Aspiring Webdeveloper from Belgium.
            </p>
            <p>
              <a
                href="https://github.com/cococoon"
                rel="noopener noreferrer"
                target="_blank"
                className="social-icon"
              >
                <FontAwesomeIcon icon={faGithub} />
              </a>
              <a
                href="https://www.linkedin.com/in/koencorneillie/"
                rel="noopener noreferrer"
                target="_blank"
                className="social-icon"
              >
                <FontAwesomeIcon icon={faLinkedin} />
              </a>
              <a
                href="https://twitter.com/kreftopdewereld"
                rel="noopener noreferrer"
                target="_blank"
                className="social-icon"
              >
                <FontAwesomeIcon icon={faTwitter} />
              </a>
            </p>
          </div>
          <div className="hero-img">
            <img
              src="https://images.unsplash.com/photo-1562844519-d2271ad99acf?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80"
              alt="brussels subway"
            />
          </div>
        </Hero>
      </div>
      {/* START EDUCATION SECTION */}
      <section id="education">
        <Fade bottom cascade>
          <div className="row">
            <h2
              style={{ textAlign: "center", marginBottom: "0", width: "100%" }}
            >
              Education
            </h2>
            {/* ONE THIRD COLUMN */}

            <div className="education">
              <h3>
                <FontAwesomeIcon icon={faCheckCircle} /> Web Development
              </h3>
              <h4>
                Professional degree <br />
                @Syntra AB <nobr>(2017-2019)</nobr>
              </h4>
              <p>
                <strong />
                <br />
                <u>Front-end:</u>
                <br />
                HTML(5), CSS(3), Javascript
                <br />
                <u>Back-end:</u>
                <br />
                MySQL, PHP, NodeJS
                <br />
                <u>Frameworks:</u>
                <br />
                Angular, React, Bootstrap
              </p>
            </div>
            {/* ONE THIRD COLUMN */}
            <div className="education">
              <h3>
                <FontAwesomeIcon icon={faCheckCircle} /> Communication Sciences
              </h3>
              <h4>
                Bachelor's degree <br />
                @Vrije Universiteit Brussel - VUB (2014)
              </h4>
              <p>
                <br />
                Marketing
                <br />
                Strategic Business Communication
              </p>
            </div>
            {/* ONE THIRD COLUMN */}
            <div className="education">
              <h3>
                <FontAwesomeIcon icon={faCheckCircle} /> Economics/Modern
                Languages
              </h3>
              <h4>@Jan van Ruusbroekcollege</h4>
            </div>
          </div>
        </Fade>
        {/* END EDUCATION SECTION */}
      </section>
      {/* START SKILLS SECTION */}
      <section id="skills">
        <div
          className="row"
          // MAIN COLOR
          style={{ backgroundColor: "rgba(153, 204, 204, 0.5)" }}
        >
          <h2 style={{ textAlign: "center", marginBottom: "0", width: "100%" }}>
            Skills
          </h2>
          <div className="skills">
            <h4>Web technologies</h4>
            <h5>HTML(5)</h5>
            <div className="bar">
              <Fade left>
                <span className="bar-content" style={{ width: "90%" }} />
              </Fade>
            </div>
            <h5>CSS(3)/SCSS</h5>
            <div className="bar">
              <Fade left>
                <span className="bar-content" style={{ width: "80%" }} />
              </Fade>
            </div>
            <h5>Javascript</h5>
            <div className="bar">
              <Fade left>
                <span className="bar-content" style={{ width: "70%" }} />
              </Fade>
            </div>
            <h5>React</h5>
            <div className="bar">
              <Fade left>
                <span className="bar-content" style={{ width: "70%" }} />
              </Fade>
            </div>
            <h5>NodeJS/Express</h5>
            <div className="bar">
              <Fade left>
                <span className="bar-content" style={{ width: "70%" }} />
              </Fade>
            </div>
            <h5>PHP</h5>
            <div className="bar">
              <Fade left>
                <span className="bar-content" style={{ width: "50%" }} />
              </Fade>
            </div>
            <h5>mySQL</h5>
            <div className="bar">
              <Fade left>
                <span className="bar-content" style={{ width: "60%" }} />
              </Fade>
            </div>
            <h5>mongoDB/mongoose</h5>
            <div className="bar">
              <Fade left>
                <span className="bar-content" style={{ width: "50%" }} />
              </Fade>
            </div>
          </div>
          <div className="skills">
            <h4>Content Management (CMS)</h4>
            <h5>Sitecore 6&9</h5>
            <div className="bar">
              <Fade left>
                <span className="bar-content" style={{ width: "90%" }} />
              </Fade>
            </div>
            <h5>Wordpress</h5>
            <div className="bar">
              <Fade left>
                <span className="bar-content" style={{ width: "80%" }} />
              </Fade>
            </div>
            <h5>Sharepoint</h5>
            <div className="bar">
              <Fade left>
                <span className="bar-content" style={{ width: "70%" }} />
              </Fade>
            </div>
            <h5>Adobe Experience Manager</h5>
            <div className="bar">
              <Fade left>
                <span className="bar-content" style={{ width: "50%" }} />
              </Fade>
            </div>
            <h5>Drupal</h5>
            <div className="bar">
              <Fade left>
                <span className="bar-content" style={{ width: "50%" }} />
              </Fade>
            </div>
          </div>
          <div className="skills">
            <h4>Other skills</h4>
            <h5>MS Office</h5>
            <div className="bar">
              <Fade left>
                <span className="bar-content" style={{ width: "90%" }} />
              </Fade>
            </div>
            <h5>Photoshop</h5>
            <div className="bar">
              <Fade left>
                <span className="bar-content" style={{ width: "50%" }} />
              </Fade>
            </div>
            <h5>Search Engine Optimisation (SEO)</h5>
            <div className="bar">
              <Fade left>
                <span className="bar-content" style={{ width: "80%" }} />
              </Fade>
            </div>
            <h5>Google Analytics</h5>
            <div className="bar">
              <Fade left>
                <span className="bar-content" style={{ width: "80%" }} />
              </Fade>
            </div>
            <h5>Google Data Studio</h5>
            <div className="bar">
              <Fade left>
                <span className="bar-content" style={{ width: "60%" }} />
              </Fade>
            </div>
            <h5>Movie knowledge</h5>
            <div className="bar">
              <Fade left>
                <span className="bar-content" style={{ width: "80%" }} />
              </Fade>
            </div>
          </div>
        </div>
      </section>
      {/* END SKILLS SECTION */}
      {/* START EXPERIENCE SECTION */}
      <section id="exp">
        <div className="row">
          <h2 style={{ textAlign: "center", width: "100%" }}>Experience</h2>
          <div className="experience">
            <h4>
              <FontAwesomeIcon icon={faBriefcase} /> Webmaster
              <br />@ TBWA Belgium (current)
            </h4>
            <ul>
              <li>Digital Content Management (Wordpress, Drupal, AEM, ...)</li>
              <li>Emailing: AEM, Mailchimp</li>
            </ul>
          </div>
          <div className="experience">
            <h4>
              <FontAwesomeIcon icon={faBriefcase} /> Digital Content Manager
              <br />@ Fluxys (2016-2019)
            </h4>
            <h5>Website Management</h5>
            <ul>
              <li>News & press releases</li>
              <li>Mailing</li>
              <li>Content writing</li>
              <li>Content management & creation</li>
              <li>Reporting (Google Analytics & Data studio)</li>
              <li>Search Engine Optimisation (SEO)</li>
              <li>Project {"for"} website renewal</li>
            </ul>

            <h5>Social Media Management</h5>
            <ul>
              <li>Content creation</li>
              <li>Monitoring (Engagor)</li>
              <li>Publishing</li>
            </ul>
            <h5>Corporate writing</h5>
            <ul>
              <li>Annual reports</li>
              <li>Various external publications</li>
              <li>News & press releases</li>
            </ul>
          </div>
          <div className="experience">
            <h4>
              <FontAwesomeIcon icon={faBriefcase} /> Communications Officer
              <br />@ Municipality Wemmel (2015)
            </h4>
            <ul>
              <li>Information Magazine (draft, layout)</li>
              <li>Content management website</li>
              <li>Social media</li>
            </ul>
          </div>
          <div className="experience">
            <h4>
              <FontAwesomeIcon icon={faBriefcase} /> Library Assistant
              <br />@ Municipality Wemmel (2013-2015)
            </h4>
            <ul>
              <li>Organisation of various activities</li>
              <li>Purchasing</li>
              <li>Database/CRM administration (Aleph)</li>
              <li>Fine administration</li>
            </ul>
          </div>
        </div>
      </section>

      {/* START CONTACT SECTION */}
      <section id="contact">
        <div className="row">
          <h2 style={{ textAlign: "center", width: "100%" }}>Contact</h2>
          <Contact />
        </div>
      </section>

      {/* END CONTACT SECTION */}
    </div>
  );
};

export default Home;
